(function() {
	var resengoContainer = '.resengo-container';
	var $resengoContainers = $(resengoContainer);
	var resengoTrigger = '.js-resengo-trigger';
	var $resengoTriggers = $(resengoTrigger);

	var openResengoModal = function(id) {
		closeResengoModals();
		var $container = $('#' + id);
		$container.show();
	};

	var closeResengoModals = function() {
		$resengoContainers.hide();
	};

	if($resengoTriggers.length) {

		$resengoTriggers.on('click', function(e) {
			var $target = $(this).closest('[data-resengo-id]');
			var id = $target.data('resengo-id');

			openResengoModal(id);
			e.preventDefault();
		});

		$resengoContainers.on('click', function(e) {
			if(!$(e.target).closest('#resengo-process-flow').length) {
				closeResengoModals();
			}
		});
	}
})();
